export default __webpack_public_path__ + "static/media/b2eBgMb.d91036c9.png";